import EventPayments from './EventPayments';

export default EventPayments;
